import React from 'react';
import PropTypes from 'prop-types';
import Button from '../base/Button/GlyphedButton';
import {FloppyDiskGlyph} from '../glyphicons/Glyphicons';
import textTranslates from './translate.json';

const SaveButton = ({className, disabled, onClick, type}) => {
    return(
        <Button
            className={className}
            disabled={disabled}
            floated="right"
            glyphComponent={<FloppyDiskGlyph className="btn-glyphicon" />}
            id="saveBtn"
            label={textTranslates.saveBtnLabel}
            type={type}
            onClick={onClick}/>
    );
};

SaveButton.propTypes = {
    //Class applied to component.
    className: PropTypes.string,
    //Should button be disabled.
    disabled: PropTypes.bool,
    //Fuction triggered while button is clicked.
    onClick: PropTypes.func,
    //Button display text.
    saveBtnLabel: PropTypes.string,
    //Button type.
    type: PropTypes.string,
};

export default SaveButton;


// WEBPACK FOOTER //
// ./src/components/Buttons/SaveButton.js